// extracted by mini-css-extract-plugin
export default {"global":"style_global__NzYuM","highlight":"style_highlight__4LNZv","presentation":"style_presentation__O-Q+6","noWrap":"style_noWrap__7RTgW"};